import { MEAL_PLAN_ACCESS } from './accessRules';
import { canAccess } from './canAccess';
import { useNavAccess } from './useNavAccess';

/**
 * Whether the user may see nutrition / meal-plan surfaces, resolved from the
 * single `MEAL_PLAN_ACCESS` rule via the shared `canAccess` predicate. The
 * sidebar entry and the workout-plan widget both gate on this, so they stay in
 * sync. Readiness (auth + `/features` + flags) is a separate concern — gate on
 * `selectIsNavReady` for the loading state.
 */
export const useCanAccessMealPlan = (): boolean => canAccess(MEAL_PLAN_ACCESS, useNavAccess());
